module.exports = __webpack_public_path__ + "static/media/Apple iPad Mini Space Grey.d00cda93.png";